import type { FocusEvent } from 'react';

/**
 * This should be used on blur event to close the component when the focus goes outside the component.
 * @param event
 * @param setIsOpened
 * @param container - focusing outside this container will trigger close
 * @param exceptionElement - moving focus to this element will not trigger close even if it's outside the container
 * @param isOpened
 * @param callback - optional callback to call when focus is outside the container
 */
const closeOnFocusOutside = (
	event: FocusEvent<HTMLDivElement, Element>,
	setIsOpened: (value: boolean) => void,
	container: HTMLElement | null,
	exceptionElement: HTMLElement | null,
	isOpened: boolean,
	callback?: () => void
) => {
	if (!container || !isOpened) return;

	const focusedOutside = !container.contains(event.relatedTarget);

	const focusedException =
		exceptionElement !== null &&
		exceptionElement?.contains(event.relatedTarget);

	if (focusedOutside && !focusedException) {
		setIsOpened(false);
		callback?.();
	}
};

export default closeOnFocusOutside;
